import type { Schema, SchemaField } from '@cli-types/core-engine/schema.js'
import { toPascalCase } from '@cli-utils/text.js'
import { renderSingleFormBuildGroupCreatableSelectHandlersRenderer } from '@next-adapter/templates/renderers/generators/form/form-single/build-group-creatable-select-handlers.js'

export function buildGroupCreatableSelectHandlers(
  fields: SchemaField[],
  schema: Schema,
  Singular: string,
  defaultValueFromSourceNames: Set<string>
): string {
  return fields
    .map((field) => {
      const fieldPascal = toPascalCase(field.name)
      const defaultValueFromHandler = defaultValueFromSourceNames.has(field.name)
        ? `applyDefaultValueFrom${fieldPascal}`
        : null
      const setCreatedOptionValue = field.multiple
        ? renderSingleFormBuildGroupCreatableSelectHandlersRenderer({
            kind: 'renderBuildGroupCreatableSelectHandlersCurrentValueTemplate',
            props: {
              fieldName: field.name,
              defaultValueFromHandlerContent: defaultValueFromHandler
                ? `${defaultValueFromHandler}(nextValues)\n      `
                : ''
            }
          })
        : renderSingleFormBuildGroupCreatableSelectHandlersRenderer({
            kind: 'renderBuildGroupCreatableSelectHandlersContentTemplate',
            props: {
              defaultValueFromHandlerContent: defaultValueFromHandler
                ? `${defaultValueFromHandler}(result.option.value)\n      `
                : '',
              fieldName: field.name
            }
          })
      return renderSingleFormBuildGroupCreatableSelectHandlersRenderer({
        kind: 'renderBuildGroupCreatableSelectHandlersTrimmedLabelTemplate',
        props: {
          fieldPascal: fieldPascal,
          singular: Singular,
          fieldName: field.name,
          schemaName: schema.name,
          setCreatedOptionValue: setCreatedOptionValue
        }
      })
    })
    .join('\n\n')
}
